<template>
  <div class="maxcontainer container">
    <div class="date-controls">
      <div class="date-inputs">
        <input 
          type="datetime-local" 
          v-model="startDateTime" 
          class="datetime-input"
          :max="maxStartDateTime"
          :min="minStartDateTime"
        >
        <input 
          type="datetime-local" 
          v-model="endDateTime" 
          class="datetime-input"
          :max="maxEndDateTime"
          :min="minEndDateTime"
        >
        <button 
          @click="fetchSiloProfiles" 
          class="search-button"
        >
          Buscar
        </button>
      </div>
    </div>
    <div class="sensors-grid">
      <!-- <div v-for="sensorData in sensors" :key="sensorData.sensor" class="sensor-card">
        <h3>{{ sensorData.name }}</h3>
        <div class="sensor-info">
          <p>Nivel: {{ sensorData.last_hour_level }}%</p>
          <p>Peso: {{ sensorData.last_hour_weight.toFixed(2) }} kg</p>
          <p>Última actualización: {{ formatDate(sensorData.datetime) }}</p>
          <p>dailySiloProfiles</p>
        </div>
      </div> -->
      <PageLoader v-if="loading && !hasLoadedProfiles"/>
      <div v-else-if="!loading && !hasLoadedProfiles" class="container-warnig">
        <div class="warning">
          <div class="text">
            <div style="text-align: center">Não existe dados para o intervalo de dados selecionado</div>
          </div>
        </div>
      </div>
      <div v-else>
        <div v-if="loading" class="loading-progress-text">Carregando dados...</div>
        <AccFood :siloProfiles="siloProfiles" :foodsByCompany="foodsByCompany" :is-loading="loading"/>
      </div>
    </div>
  </div>
</template>

<script>
import AccFood from "./AccFood.vue"
import PageLoader from "./Loader.vue"
import { format, parseISO, isValid, subDays } from 'date-fns'
import { sensorScreenBlocked } from '../utils/feedInventoryAccess'

export default {
  name: 'AccFoodPage',
  components: {
    AccFood,
    PageLoader
  },
  data() {
    return {
      siloProfiles: [],
      loading: false,
      startDateTime: '',
      endDateTime: '',
      activeRequestId: 0
    }
  },
  computed: {
    batch() {
      return this.$store.getters.getBatchTarget
    },
    isBatchClosed() {
      return this.batch?.date_departure != null
    },
    barnTarget() {
      return this.$store.getters.getBarnTarget
    },
    barnPk() {
      return this.barnTarget?.pk ?? this.barnTarget?.id ?? null
    },
    maxStartDateTime() {
      if (!this.endDateTime) return null
      const end = new Date(this.endDateTime)
      const max = new Date(end)
      max.setDate(max.getDate() - 1)
      return this.toDateTimeLocal(max)
    },
    minStartDateTime() {
      if (this.isBatchClosed && this.batch?.date_accomodation) {
        return this.formatDateTimeLocal(this.batch.date_accomodation)
      }
      if (!this.endDateTime) return null
      const end = new Date(this.endDateTime)
      const min = new Date(end)
      min.setDate(min.getDate() - 30)
      return this.toDateTimeLocal(min)
    },
    maxEndDateTime() {
      if (this.isBatchClosed && this.batch?.date_departure) {
        return this.formatDateTimeLocal(this.batch.date_departure)
      }
      if (!this.startDateTime) return null
      const start = new Date(this.startDateTime)
      const max = new Date(start)
      max.setDate(max.getDate() + 30)
      return this.toDateTimeLocal(max)
    },
    minEndDateTime() {
      if (this.isBatchClosed && this.batch?.date_accomodation) {
        const start = this.formatDateTimeLocal(this.batch.date_accomodation)
        if (!start) return null
        const min = new Date(start)
        min.setDate(min.getDate() + 1)
        return this.toDateTimeLocal(min)
      }
      if (!this.startDateTime) return null
      const start = new Date(this.startDateTime)
      const min = new Date(start)
      min.setDate(min.getDate() + 1)
      return this.toDateTimeLocal(min)
    },
    listFeed() {
      return this.$store.getters.getSensorsListFeed
    },
    sensors() {
      if (!this.barnPk) return []
      const feedByBarn = this.listFeed.find((feed) => {
        return String(feed?.barn?.pk) === String(this.barnPk)
      })
      if (!feedByBarn || !Array.isArray(feedByBarn.data)) return []
      return feedByBarn.data
    },
    hasLoadedProfiles() {
      return this.siloProfiles.some((profiles) => Array.isArray(profiles) && profiles.length > 0)
    },
    farm() {
      if (!this.barnPk) return null
      return this.$store.getters.getAllBarns.find((obj) => {
        return obj.barn.find((barn) => barn.pk == this.barnPk)
      }) || null
    },
    companyPk() {
      const company = this.farm?.farm?.company
      return company?.pk ?? company?.id ?? company ?? null
    },
    foodsByCompany() {
      if (!this.companyPk) return []
      return this.$store.getters.getFoodsByCompany(this.companyPk) || []
    }

  },
  watch: {
    async barnPk(newValue, oldValue) {
      if (newValue === oldValue) return

      this.applyDefaultDateRange()
      await this.ensureFoodsLoaded()
      const hydrated = this.hydrateFromStoreCache()
      if (!hydrated) {
        await this.fetchSiloProfiles()
      }
    }
  },
  methods: {
    toDateTimeLocal(date) {
      return format(date, "yyyy-MM-dd'T'HH:mm")
    },
    formatDateTimeLocal(dateStr) {
      if (!dateStr) return null
      const normalized = String(dateStr).trim().replace(' ', 'T')
      let parsed = parseISO(normalized)
      if (!isValid(parsed)) {
        parsed = new Date(dateStr)
      }
      if (!isValid(parsed)) return null
      return this.toDateTimeLocal(parsed)
    },
    getDefaultDateRange() {
      if (this.isBatchClosed) {
        return {
          startDateTime: this.formatDateTimeLocal(this.batch.date_accomodation),
          endDateTime: this.formatDateTimeLocal(this.batch.date_departure),
        }
      }
      return {
        startDateTime: format(subDays(new Date(), 7), "yyyy-MM-dd'T'HH:mm"),
        endDateTime: format(new Date(), "yyyy-MM-dd'T'HH:mm"),
      }
    },
    applyDefaultDateRange() {
      const { startDateTime, endDateTime } = this.getDefaultDateRange()
      if (startDateTime) this.startDateTime = startDateTime
      if (endDateTime) this.endDateTime = endDateTime
    },
    wait(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms))
    },
    hydrateFromStoreCache() {
      if (this.isBatchClosed) return false

      const cached = this.$store.getters.getCachedAccFoodDataByBarn(this.barnPk, 30)
      if (!cached) return false

      this.startDateTime = cached.startDateTime || this.startDateTime
      this.endDateTime = cached.endDateTime || this.endDateTime
      this.siloProfiles = Array.isArray(cached.siloProfiles) ? cached.siloProfiles : []
      return true
    },
    persistToStoreCache() {
      if (this.barnPk == null) return
      this.$store.commit('setAccFoodDataByBarn', {
        barnPk: this.barnPk,
        startDateTime: this.startDateTime,
        endDateTime: this.endDateTime,
        siloProfiles: this.siloProfiles,
        lastUpdated: new Date().toISOString()
      })
    },
    formatDate(dateString) {
      const date = new Date(dateString)
      return date.toLocaleString()
    },
    async ensureFoodsLoaded() {
      if (!this.companyPk) return
      if (this.foodsByCompany.length > 0) return
      await this.$store.dispatch('fetchFoodByCompany', this.companyPk)
    },
    async fetchSingleSensorProfiles(sensor, requestId, delayMs = 0) {
      if (delayMs > 0) {
        await this.wait(delayMs)
      }
      if (requestId !== this.activeRequestId) return

      try {
        const parsedData = await this.$store.dispatch('fetchSiloProfileHistory', {
          sensor_pk: parseInt(sensor.sensor),
          start_date: this.startDateTime,
          end_date: this.endDateTime
        })

        if (requestId !== this.activeRequestId) return

        if (Array.isArray(parsedData)) {
          const filteredData = parsedData.filter(profile => profile.weight !== null || profile.level !== null)
          // Atualiza progressivamente conforme cada request finaliza
          this.siloProfiles.push(filteredData)
        } else {
          console.warn('Expected array but got:', parsedData)
        }
      } catch (error) {
        console.error("Error fetching silo profiles:", error)
      }
    },
    fetchSiloProfiles: async function() {
      this.activeRequestId += 1
      const requestId = this.activeRequestId
      this.loading = true
      this.siloProfiles = [] // Limpiar datos anteriores

      const requests = this.sensors.map((sensor, index) =>
        this.fetchSingleSensorProfiles(sensor, requestId, index * 100)
      )
      await Promise.allSettled(requests)
      if (requestId !== this.activeRequestId) return
      this.loading = false
      this.persistToStoreCache()
    }
  },
  async created() {
    if (sensorScreenBlocked(this.$store.getters.getCurrentUser, this.$store.getters.getCompanySettings)) {
      this.loading = false
      return
    }
    this.applyDefaultDateRange()
    await this.ensureFoodsLoaded()
    const hydrated = this.hydrateFromStoreCache()
    if (!hydrated) {
      await this.fetchSiloProfiles()
    }
  }
}
</script>

<style scoped>
.barn-section {
  margin-bottom: 2rem;
  padding: 1rem;
  border: 1px solid #ddd;
  border-radius: 8px;
}

.sensors-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1rem;
  margin-top: 1rem;
}

.sensor-card {
  padding: 1rem;
  background-color: #f5f5f5;
  border-radius: 6px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.sensor-info {
  margin-top: 0.5rem;
}

.sensor-info p {
  margin: 0.5rem 0;
}

.date-controls {
  margin: 1rem 0;
  background-color: #f5f5f5;
  border-radius: 8px;
}

.date-inputs {
  display: flex;
  gap: 1rem;
  align-items: center;
}

.datetime-input {
  padding: 0.5rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 1rem;
}

.search-button {
  padding: 0.5rem 1rem;
  background-color: #89c25b;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 1rem;
  transition: background-color 0.2s;
}

.search-button:hover {
  background-color: #7ab04d;
}

.container-warnig {
  width: 100%;
  padding: 1rem;
}



.warning .text {
  font-size: 1rem;
  line-height: 1.5;
}

.loading-progress-text {
  color: #4b5563;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 8px;
}
</style>
